import React from "react";

export default function CardCanceled(){
    return (
        <div>Canceled</div>
    )
}